<template>
  <div class="login-page">
    <div class="login-title">
      物流后台管理系统
    </div>
    <a-form-model class="login-form" ref="loginFormRef" :model="loginForm" :rules="loginFormRules">
      <a-alert class="login-alert" :message="message" v-if="message" type="error" :show-icon="true"></a-alert>
      <a-form-model-item prop="account">
        <a-input size="large" placeholder="请输入账号" v-model="loginForm.account">
          <a-icon class="icon" slot="prefix" type="user"></a-icon>
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input-password size="large" placeholder="请输入5-12位密码" v-model="loginForm.password">
          <a-icon class="icon" slot="prefix" type="lock" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-button class="login-button" size="large" type="primary" :loading="logging" @click="handleLoginClick">
          登录</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import Base from '@/api/base.js';

export default {
  name: 'Login',

  data() {
    return {
      logging: false,
      loginForm: {
        account: '',
        password: '',
      },
      loginFormRules: {
        account: [
          {
            required: true,
            message: '账号为必填项',
          },
        ],
        password: [
          {
            required: true,
            message: '密码为必填项',
          },
          {
            min: 5,
            max: 12,
            message: `请输入5-12位密码`,
          },
        ],
      },

      message: '',
    };
  },

  methods: {
    async handleLoginClick() {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) {
          return false;
        }
        try {
          this.logging = true;
          const res = await Base.login(this.loginForm);
          //把当前登录用户ID存储起来
          localStorage.setItem('operator_id', res.data.id);
          this.$store.commit('user/setToken', res.data.token);
          await this.$router.push({ name: this.$routeName.dashboard });
        } catch (e) {
          this.message = e.msg;
        } finally {
          this.logging = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.login-page {
  height: 100%;
  background: #f0f2f5 url('../../assets/background.svg') no-repeat 50%;
  padding: 72px 0;
}

.login-title {
  text-align: center;
  font-size: 33px;
  font-weight: 500;
  color: rgba(#000, 0.85);
  font-family: Avenir, helvetica neue, Arial, Helvetica, sans-serif;
  margin-bottom: 24px;
}

.login-alert {
  margin-bottom: 24px;
}

.login-form {
  max-width: 368px;
  margin: 0 auto;
}

.icon {
  color: rgba(#000, 0.25);
}

.login-button {
  width: 100%;
}
</style>
